import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { serverDisconnect } from 'containers/ConnectionManager/actions';
import { invalidateIesV2User } from 'utils/iesV2';
import authenticationTypes from 'constants/authenticationTypes';

const enhanceWithSessionExpiryCheck = (Component) => {
  const EnhancedComponent = (props) => {
    const { currentUser } = props;
    const expiry = currentUser?.session?.expiry;
    const authenticationType = currentUser?.me?.authenticationType;

    const dispatch = useDispatch();

    useEffect(() => {
      let timeoutId;

      const detectSessionExpiry = () => {
        if (expiry) {
          const expiryTime = new Date(expiry).getTime();
          const currentTime = Date.now();
          const timeUntilExpiry = expiryTime - currentTime;

          timeoutId = setTimeout(() => {
            logout();
          }, timeUntilExpiry);
        }
      };

      detectSessionExpiry();

      // Cleanup function to clear timeout
      return () => {
        clearTimeout(timeoutId);
      };

    }, [expiry, logout, authenticationType]);

    const logout = useCallback(() => {
      if (authenticationType === authenticationTypes.IES_V2) {
        invalidateIesV2User();
      }
      dispatch(serverDisconnect());
    }, [dispatch, authenticationType]);
    
    return <Component {...props} />;
  };

  return React.memo(EnhancedComponent);
};

export default enhanceWithSessionExpiryCheck;
